import {FC} from 'react';
import {Popup} from 'semantic-ui-react';

import {BaseActionButton} from './BaseActionButton';
import Linker from '../Linker';

class ManageMultipleLinks extends BaseActionButton {
  icon = 'code branch';
  tooltip = 'Manage Multiple Links';

  visible = () => {
    const {multipleLinks} = this.rackEditorStore;
    return multipleLinks;
  };

  error = () => {
    const {canManageLinks: {why}, multipleLinks} = this.rackEditorStore;
    return multipleLinks ? why : null;
  };

  disabled = () => {
    const {multipleLinks, canManageLinks} = this.rackEditorStore;
    return !canManageLinks.result || !multipleLinks;
  };

  onClick = () => {
    this.hidePopups(false, true);
    this.rackEditorStore.rackStore.toggleLinker(undefined, this.rackEditorStore.selection);
  };

  render: FC = () => {
    const {canManageLinks, portsSpeeds, rackStore, ports: {free: freePorts}, newLinkRestriction,
      multipleLinks} = this.rackEditorStore;

    return (
      <Popup
        {...this.popupCommonProps()}
        open={multipleLinks && canManageLinks.result && rackStore.hasDraftLinks}
      >
        <Linker
          portsSpeeds={portsSpeeds}
          freePorts={freePorts}
          newLinkRestriction={newLinkRestriction}
        />
      </Popup>
    );
  };
}

export {ManageMultipleLinks};
